<template>
  <div>
    <common-list
      ref="list"
      url="VehicleBusiness/GetList"
      :init="filter"
      @currentrow="handlerCurrentRow"
    >
      <!-- 条件区域 -->
      <template v-slot:filter="{ filter }">
        <el-col :span="6">
          <el-form-item label="入场编号">
            <el-input
              v-model="filter.RegistrationNum"
              placeholder="入场编号"
              clearable
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="车牌号">
            <el-input
              v-model="filter.LicensePlate"
              placeholder="车牌号"
              clearable
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="车架号">
            <el-input
              style="width: 50%"
              v-model="filter.Vin"
              placeholder="车架号"
              clearable
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="登记状态">
            <el-select v-model="filter.IsReg" clearable>
              <el-option value="1" label="已登记"></el-option>
              <el-option value="0" label="未登记"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="称重状态">
            <el-select v-model="filter.IsWeigh" clearable>
              <el-option value="1" label="已称重"></el-option>
              <el-option value="0" label="未称重"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="结算状态">
            <el-select v-model="filter.IsSettle" clearable>
              <el-option value="1" label="已结算"></el-option>
              <el-option value="0" label="未结算"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </template>
      <!-- 按钮区域 -->
      <template v-slot:option>
        <el-button
          type="warning"
          icon="el-icon-edit"
          @click="show"
          v-if="auth('VehicleBusinessShow')"
          >查看</el-button
        >
        <el-button
          type="primary"
          icon="el-icon-tickets"
          @click="ShowAddWeighParts"
          v-if="auth('VehicleBusinessWeigh')"
          >车辆称重</el-button
        >
        <el-button
          type="warning"
          icon="el-icon-edit"
          @click="edit"
          v-if="auth('VehicleBusinessReg')"
          @success="getData"
          >车辆登记</el-button
        >
        <print
          @onClickPrint="onClickPrint"
          :options="printoptions"
          PrintName="bd,bfcljxd,bfcysd,bfczxdjb,blclbfxz,jdccyjlb"
        ></print>

        <!-- <el-button type="warning" icon="el-icon-upload2">上传商务部</el-button> -->
      </template>
      <!-- 数据展示区域 -->
      <template v-slot:body>
        <el-table-column
          label="车辆编号"
          prop="CarId"
          width="200"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="入场编号/喷漆编号"
          prop="RegistrationNum"
          width="200"
          show-overflow-tooltip
        >
          <template slot-scope="scope"
            >{{
              scope.row.RegistrationNum == 0
                ? "未编号"
                : scope.row.RegistrationNum
            }}
          </template></el-table-column
        >
        <el-table-column
          label="车牌号"
          prop="LicensePlate"
          show-overflow-tooltip
          width="120"
        ></el-table-column>

        <el-table-column
          label="车架号"
          prop="Vin"
          show-overflow-tooltip
          width="200"
        >
          <template slot-scope="scope">{{ scope.row.Vin | gang }}</template>
        </el-table-column>
        <el-table-column
          label="是否登记"
          prop="IsReg"
          show-overflow-tooltip
          width="100"
        >
          <template slot-scope="{ row }">
            <i
              :class="[
                row.IsReg == 1 ? 'el-icon-check' : 'el-icon-close',
                row.IsReg == 1 ? 'icon-checked' : 'icon-closed',
              ]"
            ></i>
          </template>
        </el-table-column>
        <el-table-column
          label="是否称重"
          prop="IsWeigh"
          show-overflow-tooltip
          width="100"
          ><template slot-scope="{ row }">
            <i
              :class="[
                row.IsWeigh == 1 ? 'el-icon-check' : 'el-icon-close',
                row.IsWeigh == 1 ? 'icon-checked' : 'icon-closed',
              ]"
            ></i></template
        ></el-table-column>
        <el-table-column
          label="是否结算"
          prop="IsSettle"
          show-overflow-tooltip
          width="100"
          ><template slot-scope="{ row }">
            <i
              :class="[
                row.IsSettle == 1 ? 'el-icon-check' : 'el-icon-close',
                row.IsSettle == 1 ? 'icon-checked' : 'icon-closed',
              ]"
            ></i></template
        ></el-table-column>
        <el-table-column label="登记员" prop="RegUserId" show-overflow-tooltip
          ><template slot-scope="{ row }">
            {{ row.RegUser | gang }}
          </template></el-table-column
        >
        <el-table-column label="司磅员" prop="WeighUserId" show-overflow-tooltip
          ><template slot-scope="{ row }">
            {{ row.WeighUser | gang }}
          </template></el-table-column
        >
        <el-table-column
          label="结算员"
          prop="SettleUserId"
          show-overflow-tooltip
          ><template slot-scope="{ row }">
            {{ row.SettleUser | gang }}
          </template></el-table-column
        >
        <el-table-column label="状态" prop="QueueStatus" show-overflow-tooltip>
          <template slot-scope="{ row }">
            <el-tag
              v-if="row.QueueStatus == 2"
              size="medium"
              type="success"
              effect="dark"
            >
              {{ row.QueueStatus | enumer("register_queue_state") }}
            </el-tag>
            <el-tag
              v-if="row.QueueStatus == 3"
              size="medium"
              type="danger"
              effect="dark"
            >
              {{ row.QueueStatus | enumer("register_queue_state") }}
            </el-tag>
            <el-tag
              v-if="row.QueueStatus == 4"
              size="medium"
              type="warning"
              effect="dark"
            >
              {{ row.QueueStatus | enumer("register_queue_state") }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.IsSettle != 1"
              size="mini"
              type="warning"
              @click="ShowSettlementParts(scope.row)"
              >结算</el-button
            >
          </template>
        </el-table-column>
      </template>
    </common-list>
    <!-- 弹窗区域 -->
    <div>
      <AddWeighDialog
        :item="itemAddWeighShow"
        @success="getData"
      ></AddWeighDialog>
      <ShowSettlementDialog
        :item="itemSettlementShow"
        @success="getData"
      ></ShowSettlementDialog>
    </div>
  </div>
</template>

<script>
// import "viewerjs/dist/viewer.css";
import AddWeighDialog from "./Weigh";
import ShowSettlementDialog from "./Settlement";
export default {
  components: {
    AddWeighDialog,
    ShowSettlementDialog,
  },
  computed: {},
  data() {
    return {
      Status: [],
      itemAddWeighShow: {},
      itemSettlementShow: {},
      filter: {
        StatusArray: [],
      },
      radio: 1,
      srcList: [],
      printoptions: {}, //打印参数
    };
  },
  watch: {},
  methods: {
    ChangeStatus(filter) {
      filter.Status = this.Status.join(",");
    },
    getData() {
      this.$refs.list.getTableData();
    },
    showImg(path) {
      this.srcList.push(path);
    },

    add() {
      this.$router.push({
        name: "VehicleRegistAddEdit/:KeyId/:IsEdit",
        params: {
          KeyId: "1",
          IsEdit: false,
        },
      });
    },
    edit() {
      if (!this.hasCurrentRow()) {
        return;
      }
      if (this.currentrow.QueueStatus == "4") {
        this.$message.error("已办结，不允许修改登记信息");
        return;
      }
      this.$router.push({
        name: "VehicleRegistAddEdit/:KeyId/:IsEdit",
        params: {
          KeyId: this.currentrow.CarId,
          IsEdit: true,
        },
      });
    },
    show() {
      if (!this.hasCurrentRow()) {
        return;
      }
      this.$router.push({
        name: "VehicleRegistShow/:KeyId/:IsEdit",
        params: {
          KeyId: this.currentrow.CarId,
          IsEdit: true,
        },
      });
    },
    ShowMissingParts() {
      if (!this.hasCurrentRow()) {
        return;
      }
      this.itemMissingPartsShow = {
        KeyId: this.currentrow.KeyId,
      };
    },
    ShowSettlementParts(row) {
      if (row.IsWeigh == 1) {
        this.$confirm(
          `你将对编号为【${row.RegistrationNum}】的车辆进行结算, 是否继续?`,
          "提示信息",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            cancelButtonClass: "el-button--canale",
            type: "warning",
          }
        )
          .then(() => {
            this.itemSettlementShow = {
              KeyId: row.CarId,
            };
          })
          .catch(() => {});
      } else {
        this.$message.error("未称重车辆不允许结算");
        return;
      }
    },
    ShowAddWeighParts() {
      if (!this.hasCurrentRow()) {
        return;
      }
      if (this.currentrow.QueueStatus == "4") {
        this.$message.error("已办结，不允许称重");
        return;
      }
      if (this.currentrow.IsWeigh == "1") {
        this.$message.error("已称重，不允许重复称重");
        return;
      }
      this.itemAddWeighShow = {
        KeyId: this.currentrow.CarId,
      };
    },
    deleteItem() {
      if (!this.hasCurrentRow()) {
        return;
      }
      if (this.currentrow.InfoState != "1") {
        this.$message.error("只能删除车辆状态为已收车的车辆");
        return;
      }
      this.$confirm(
        `将删除登记编号为【${this.currentrow.KeyId}】的数据, 是否继续?`,
        "提示信息",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          cancelButtonClass: "el-button--canale",
          type: "warning",
        }
      )
        .then(() => {
          this.$delete("VehicleRegistration/DeleteVehicleRegistration", {
            KeyId: this.currentrow.KeyId,
          }).then(() => {
            this.$message.success("删除成功");
            this.getData();
          });
        })
        .catch(() => {});
    },
    onClickPrint(type, callback) {
      if (!this.hasCurrentRow()) {
        return;
      }
      var id = this.currentrow.CarId;
      if (id == null || id.length == 0) {
        this.$message.error("未获取选中的列表");
        return;
      }
      this.printoptions = { id: id };
      callback(this.printoptions); //callback 执行打印 false不执行
    },
  },
};
</script>

<style>
.icon-checked {
  color: green;
}
.icon-closed {
  color: red;
}
</style>
